<div class="mmc-settings-billing-tier-container">
<!--    <div class="mmc-counter-label"> {{getCount() + ' Billing Tiers'}}</div>-->
    <irb-inventory-grid
            class="mmc-settings-billing-tier-grid-ag"
            id="mmc-settings-billing-tier-grid-ag"
            [style.width]="'100%'"
            [gridHeight]="'200px'"
            [showSideBar]="false"
            [gridOptions]="gridOptions"
            [frameworkComponents]='frameworkComponents'
            [rowData]="data"
            (gridReady)="onGridReady($event)"></irb-inventory-grid>
</div>


